import About from "./components/About";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import Alert from "./components/Alert";
import { useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  // Link
} from "react-router-dom";

function App() {
  const [theme, setTheme] = useState('light');
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    })
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  }

  const toggleMode = () => {
    if (theme === 'light') {
      setTheme('dark');
      document.body.style.backgroundColor = "#18181b"
      showAlert("Dark mode enable successfully", "success");
    } else {
      setTheme('light');
      document.body.style.backgroundColor = "white";
      showAlert("Light mode enable successfully", "success");
    }
  }


  return (
    <>
      <Router>
        <Navbar title="Txt-Converter" theme={theme} toggleMode={toggleMode} />
        <Alert alert={alert} />
        <Switch>
          <Route exact path="/about">
            <About />
          </Route>
          <Route exact path="/">
            <TextForm showAlert={showAlert} heading="Enter The Text To Analyze" theme={theme} />
          </Route>
        </Switch>
      </Router>



    </>
  );
}

export default App;
